import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { Subject } from 'rxjs';
import { Option } from '../../models/option.model';

/**
 * @deprecated
 */
@Component({
  selector: 'partnerhub-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  styleUrls: ['./checkbox-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxGroupComponent),
      multi: true,
    },
  ],
})
export class CheckboxGroupComponent implements OnInit, OnDestroy, ControlValueAccessor {
  public get _horizontal(): boolean {
    if (this.horizontal === '' || this.horizontal) {
      return true;
    }
    return false;
  }

  get invalid(): boolean {
    return this.touched && this.errors !== null;
  }

  private readonly complete$ = new Subject();

  private value: any[] = [];

  @Input() public disabledOptions: Option[] = [];

  @Input() public errors: ValidationErrors = null;

  @Input() public groupName: string;
  @Input() public horizontal: boolean | string = false;

  @Input() public label: string;

  @Input() public options: Option[] = [];

  public touched = false;

  constructor() {}

  public isDisabled(id: number): boolean {
    return this.disabledOptions.some((option) => option.id === id);
  }

  public isValueSelected(option: Option): boolean {
    return this.value.some((elem) => elem.id === option.id);
  }

  public ngOnDestroy() {
    this.complete$.next(true);

    this.complete$.complete();
  }

  public ngOnInit() {}

  public onBlur() {
    this.touched = true;
  }

  public onChange = (_: any[]) => {};

  public onCheckChange(event, index: number): void {
    if (event.target.checked) {
      this.value.push(this.options[index]);
    } else {
      this.value = this.value.filter((elem) => elem.value !== this.options[index].value);
    }

    this.onChange(this.value);
  }

  public onTouch = () => {};

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public writeValue(value: any[]): void {
    if (value) {
      this.value = value;
    } else {
      this.value = [];
    }

    this.onChange(this.value);
  }
}
